import { render, staticRenderFns } from "./addDict.vue?vue&type=template&id=4eb14744&"
import script from "./addDict.vue?vue&type=script&lang=js&"
export * from "./addDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb14744')) {
      api.createRecord('4eb14744', component.options)
    } else {
      api.reload('4eb14744', component.options)
    }
    module.hot.accept("./addDict.vue?vue&type=template&id=4eb14744&", function () {
      api.rerender('4eb14744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/dictionary/addDict.vue"
export default component.exports